import Category from "../models/category/category.model";
import React from "react";
import {SelectInput} from "../../components/form/select.input";
import CategoryAnswer from "../models/answer/categoryAnswer.model";
import {Control, UseFormRegister} from "react-hook-form/dist/types/form";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {QuizType} from "../enums/quizType.enum";
import {QuestionAnswering} from "@carbon/icons-react";
import {FormLabel, SelectChangeEvent, Theme} from "@mui/material";
import Box from "@mui/material/Box";
import Personality from "../icons/brand/personality";
import StarSign from "../icons/brand/starSign";
import LoveHeart from "../icons/brand/loveHeart";
import {FieldError, FieldErrors} from "react-hook-form";

//Using any because having issues trying to figure out how to type this correctly
interface GenerateCategorySelectProps{
    category: Category;
    register: UseFormRegister<any>;
    registerOptions?: RegisterOptions<any, any>;
    control: Control<any>;
    onChangeWithCategoryContext?: (category: Category) => (e: SelectChangeEvent<unknown>) => void;
    onValidateWithCategoryContext?: (category: Category) => () => boolean | string | undefined;
    errors: FieldErrors;
    isChild?: boolean;
    placeHolder?: string;
}

export class CategoryGeneratorHelper {
    
    private static constructOptionLabel(categoryAnswer: CategoryAnswer) {

        let label = categoryAnswer.label;

        if(categoryAnswer.descriptor) {
            label += ` - ${categoryAnswer.descriptor}`;
        }

        return label;
    }

    static generateCategorySelect(props : GenerateCategorySelectProps) {
        const {
            category,
            register,
            registerOptions,
            control,
            errors,
            onChangeWithCategoryContext,
            onValidateWithCategoryContext,
            isChild,
            placeHolder
        } = props;

        if(category.answers && category.answers.length)
        {
            const errorAnswers = errors['answers'] as Record<string, FieldError>;
            const categoryAnswerError = errorAnswers ? errorAnswers[`category${category.id}`] : null;

            return <Box>
                {
                    !isChild &&
                    <FormLabel
                        sx={{ whiteSpace: "pre-wrap", mb: 0.5, display: "block" }}
                        className={"input-label"}
                    >
                        {category.subtitle ?? category.title}
                    </FormLabel>
                }
                <SelectInput
                    key={category.id}
                    {...register(`answers.category${category.id}`, {
                        ...registerOptions,
                        onChange: typeof onChangeWithCategoryContext === "function" ? onChangeWithCategoryContext(category) : undefined,
                        validate: typeof onValidateWithCategoryContext === "function" ? onValidateWithCategoryContext(category) : undefined,
                    })}
                    getOptionLabel={o => this.constructOptionLabel(o as CategoryAnswer)}
                    getOptionValue={o => (o as CategoryAnswer).id}
                    placeholder={placeHolder}
                    hidePlaceholderMenuItem={true}
                    items={category.answers}
                    fieldMapper={(value, items) => items.find(i => (i as CategoryAnswer).id == value)}
                    valueMapper={(value) => value.id}
                    control={control}
                    error={Boolean(categoryAnswerError)}
                    errorMessage={categoryAnswerError?.message as string}
                />
            </Box>;
        }

        return <>
        {
                category.children && category.children.length ? category.children.map((child: Category, index: number) => {
                        return <Box key={`childCategory${child.id}`} marginTop={index !== 0 ? 2 : undefined}>
                            <FormLabel
                                sx={{ whiteSpace: "pre-wrap", mb: 0.5, display: "block" }}
                                className={"input-label"}
                            >
                                {child.subtitle}
                            </FormLabel>
                            {this.generateCategorySelect({
                                category: child,
                                registerOptions,
                                register,
                                control,
                                onChangeWithCategoryContext,
                                onValidateWithCategoryContext,
                                errors,
                                placeHolder,
                                isChild: true
                            })}
                        </Box>;
                    })
                    : <></>
            }
        </>;
    }

    static getCategoryIcon(theme: Theme, quizType?: QuizType) {

        switch (quizType) {
            case QuizType.MBTI: {
                return <Personality
                    fill={theme.palette.thatsMe.iconEclipse}
                    size={26}
                />;
            }
            case QuizType.StarSign: {
                return <StarSign
                    fill={theme.palette.thatsMe.iconStar}
                    size={26}
                />;
            }
            case QuizType.LoveLanguage: {
                return <LoveHeart
                    fill={theme.palette.thatsMe.iconHeart}
                    size={26}
                />;
            }
            default: {
                return <QuestionAnswering
                    fill={theme.palette.thatsMe.iconEclipse}
                    size={26}
                />;
            }
        }
    }
}